(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ux-enhancements"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-ux-open-details]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ux-mobile-action"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-ux-action]');
    if (!bar) return;
    const button = bar.querySelector('[data-ux-action-button]');
    const price = bar.querySelector('[data-ux-action-price]');
    const mode = bar.dataset.uxAction;
    const smallScreen = matchMedia('(max-width:749px)');
    const scope = document.querySelector(mode === 'product' ? 'product-info' : '#MainContent');
    if (!scope) return;
    let queued = false;
    let nativeButton;
    const visible = el => !!el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
    const update = () => {
      queued = false;
      if (mode === 'product') {
        nativeButton = scope.querySelector('product-form button[name="add"]');
        const notify = scope.querySelector('button.gw-button-widget[gw-stock-fulfilled]');
        if (notify && notify.textContent !== bar.dataset.uxNotify) notify.textContent = bar.dataset.uxNotify;
        const priceRoot = scope.querySelector('[id^="price-"]');
        const currentPrice = priceRoot?.querySelector(priceRoot.querySelector('.price--on-sale') ? '.price-item--sale' : '.price-item--regular');
        const qty = scope.querySelector('input[name="quantity"]');
        const taxLabel = currentPrice?.dataset.taxLabel || '';
        const quantityPrefix = smallScreen.matches ? '' : (qty?.value && qty.value !== '1' ? qty.value + ' ×' : '');
        price.textContent = [quantityPrefix, currentPrice?.textContent.trim(), taxLabel].filter(Boolean).join(' ');
      } else {
        nativeButton = Array.from(scope.querySelectorAll('#checkout-exemptify, #checkout')).find(visible);
        price.textContent = scope.querySelector('[data-order-total], .totals__total-value')?.textContent.replace(/\s+/g, ' ').trim() || '';
      }
      const active = document.activeElement;
      const editing = active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName);
      const rect = nativeButton?.getBoundingClientRect();
      const empty = mode === 'cart' && !!scope.querySelector('cart-items.is-empty');
      const passedProductButton = mode !== 'product' || (rect && rect.bottom < 0);
      const pendingQuantity = mode === 'cart' && Array.from(scope.querySelectorAll('input[name="updates[]"]')).some(input => input.value !== input.getAttribute('value'));
      const cartLoading = pendingQuantity || !!scope.querySelector('.cart__items--disabled');
      bar.setAttribute('aria-busy', String(cartLoading));
      if (cartLoading) price.textContent = bar.dataset.uxLoading;
      const disabled = cartLoading || !nativeButton || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true';
      button.disabled = disabled;
      const label = mode === 'cart' ? [bar.dataset.uxCheckout, price.textContent].filter(Boolean).join(' — ') : nativeButton?.innerText.trim();
      if (label && button.textContent !== label) button.textContent = label;

      const viewportAllowed = mode === 'product' || smallScreen.matches || (mode === 'cart' && matchMedia('(min-width:990px)').matches);
      bar.hidden = !viewportAllowed || !nativeButton || empty || !passedProductButton || editing || (mode === 'cart' && rect && rect.top >= 0 && rect.bottom <= window.innerHeight);
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    new MutationObserver(schedule).observe(scope, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','value','style']});
    document.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    document.addEventListener('focusin', schedule);
    document.addEventListener('focusout', schedule);
    scope.addEventListener('input', schedule);
    scope.addEventListener('change', schedule);
    button.addEventListener('click', () => {
      update();
      if (button.disabled || !nativeButton) return;
      button.disabled = true;
      nativeButton.click();
      schedule();
    });
    window.addEventListener('pageshow', schedule);
    update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ux-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ux-catalogue-menu')) {
 customElements.define('ux-catalogue-menu', class extends HTMLElement {
  connectedCallback() {
   if(this.ready) return;
   this.ready=true;
   const toggle=this.querySelector('.ux-menu-toggle'),dialog=this.querySelector('dialog');
   if(!toggle||!dialog) return;
   let savedY=0,oldTop='',restored=true;
   const restore=()=>{if(restored)return;restored=true;document.body.classList.remove('ux-navigation-open');document.body.style.top=oldTop;window.scrollTo({top:savedY,behavior:'instant'});toggle.setAttribute('aria-expanded','false');toggle.focus({preventScroll:true});};
   toggle.addEventListener('click',()=>{savedY=window.scrollY;oldTop=document.body.style.top;restored=false;dialog.showModal();document.body.style.top=`-${savedY}px`;document.body.classList.add('ux-navigation-open');toggle.setAttribute('aria-expanded','true');dialog.querySelector('.ux-menu-close').focus({preventScroll:true});});
   dialog.querySelector('.ux-menu-close').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('close',restore);
   dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
   dialog.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{dialog.close();restore();}));
   dialog.querySelectorAll('.ux-menu-group').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)dialog.querySelectorAll('.ux-menu-group').forEach(other=>{if(other!==d)other.open=false;});}));
   matchMedia('(min-width:990px)').addEventListener('change',e=>{if(e.matches&&dialog.open)dialog.close();});
   window.addEventListener('pageshow',()=>{if(dialog.open)dialog.close();restore();});
  }
 });
}
document.querySelectorAll('.ux-catalogue-desktop').forEach(nav=>{
 const groups=Array.from(nav.querySelectorAll('.ux-nav-group'));
 groups.forEach(d=>d.addEventListener('toggle',()=>{if(d.open)groups.forEach(other=>{if(other!==d)other.open=false;});}));
 nav.addEventListener('keydown',e=>{if(e.key==='Escape'){const d=groups.find(x=>x.open);if(d){d.open=false;d.querySelector('summary').focus();}}});
 document.addEventListener('click',e=>{if(!nav.contains(e.target))groups.forEach(d=>d.open=false);});
 nav.addEventListener('focusout',()=>{requestAnimationFrame(()=>{if(!nav.contains(document.activeElement))groups.forEach(d=>d.open=false);});});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ux-typography"] && !Shopify.designMode) return;
  try {
    function compactEmptyRichText(root) {
    root.querySelectorAll('.rte p').forEach((paragraph) => {
      if (paragraph.textContent.trim() || paragraph.id) return;
      if (paragraph.querySelector('img,svg,video,audio,iframe,canvas,object,embed,input,button,a,select,textarea')) return;
      paragraph.classList.add('ux-empty-paragraph');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => compactEmptyRichText(document), { once: true });
  } else {
    compactEmptyRichText(document);
  }
  document.addEventListener('shopify:section:load', (event) => compactEmptyRichText(event.target));
  } catch(e) { console.error(e); }
})();

})();
